import { Button, Divider, Grid, Typography } from '@mui/material'
import React, { useEffect, useState } from 'react'
import { getFichajesPendientes, updateFichajePendiente } from '../../services/apis';
import KeyboardDoubleArrowRightIcon from '@mui/icons-material/KeyboardDoubleArrowRight';
import DoneAllIcon from '@mui/icons-material/DoneAll';
import BlockIcon from '@mui/icons-material/Block';
import { DialogAceptarModificacion } from './DialogAceptarModificacion';
import { DialogRechazarModificacion } from './DialogRechazarModificacion';
import { formatearFecha } from '../../utils/utils';

export const FichajesPendientes = () => {

    const [fichajesPendientes, setFichajesPendientes] = useState([]);
    const [open, setOpen] = useState(null);
    const [open2, setOpen2] = useState(null);

    // --- FUNCION CLAVE ---
    // Determina el ID con el que debe abrirse el dialog
    const getDialogId = (fichaje) => {
        if (fichaje.tipo === "correccion") {
            return fichaje.fichaje_modificado?.id; // SIEMPRE este para correcciones
        }
        return fichaje.fichaje_original?.id ?? fichaje.id_fichaje; // anulaciones
    };

    const cargarFichajesPendientes = async () => {
        try {
            const response = await getFichajesPendientes();
            if (response.success) {
                setFichajesPendientes(response.data);
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    const actualizarFichajePendiente = async (id, accion, tipo) => {
        let data =
            tipo === "correccion"
                ? { id_fichaje: id, correccion_aceptada: accion }
                : { id_fichaje: id, anulacion_respuesta: accion };

        try {
            const response = await updateFichajePendiente(data);
            if (response.success) {
                setOpen(null);
                setOpen2(null);
                cargarFichajesPendientes();
            }
        } catch (error) {
            console.error("Error:", error);
        }
    };

    useEffect(() => {
        cargarFichajesPendientes();
    }, []);

    return (
        <Grid container justifyContent="center" xs={12}>

            <Grid container xs={12} sx={{ mb: 1 }}>
                <Typography variant='h5'>Fichajes pendientes de aceptar o rechazar</Typography>
                <Divider sx={{ width: '100%', my: 1 }} />
            </Grid>

            {fichajesPendientes.length === 0 ? (
                <Grid container justifyContent="center" xs={12}>
                    <Typography>No hay fichajes pendientes.</Typography>
                </Grid>
            ) : (
                <Grid container xs={12} gap={2}>

                    {fichajesPendientes.map((fichaje, index) => {

                        const isCorreccion = fichaje.tipo === "correccion";
                        const isAnulacion = fichaje.tipo === "anulacion";
                        const dialogId = getDialogId(fichaje);

                        return (
                            <Grid
                                key={dialogId}
                                container xs={12} lg={5.9}
                                sx={{
                                    p: 1,
                                    borderRadius: 2,
                                    boxShadow: 2,
                                    background: "var(--fondoTarjeta)"
                                }}
                            >

                                {/* CABECERA */}
                                <Grid container direction="column" xs={12}>
                                    <Typography variant='h6'>
                                        {(fichaje.fichaje_original?.nombre_usuario ??
                                            fichaje.fichaje_modificado?.nombre_usuario ??
                                            "Usuario desconocido")}
                                        {" - Fichaje Nº" + dialogId}
                                    </Typography>

                                    {isCorreccion && (
                                        <Typography variant='body2'>
                                            Este fichaje fue modificado por un administrador.
                                        </Typography>
                                    )}

                                    {isAnulacion && (
                                        <Typography variant='body2'>
                                            Este fichaje fue anulado por un administrador.
                                        </Typography>
                                    )}

                                    <Divider sx={{ width: '100%', my: 1.5 }} />
                                </Grid>

                                {/* === CORRECCIÓN === */}
                                {isCorreccion && (
                                    <>
                                        {/* ORIGINAL (si existe) */}
                                        {fichaje.fichaje_original && (
                                            <>
                                                <Grid container xs={5.5} sx={{
                                                    backgroundColor: 'lightgray',
                                                    p: 0.5,
                                                    borderLeft: "5px solid gray",
                                                    borderRadius: 2,
                                                }}>
                                                    <Typography variant='subtitle1'>Fichaje original</Typography>
                                                    <Divider sx={{ width: '100%', my: 0.5 }} />

                                                    <Typography variant='body2'>
                                                        Inicio: {formatearFecha(fichaje.fichaje_original.hora_inicio)}&nbsp;
                                                    </Typography>
                                                    <Typography variant='body2'>
                                                        Fin: {formatearFecha(fichaje.fichaje_original.hora_fin)}
                                                    </Typography>
                                                </Grid>

                                                <Grid container xs={1} justifyContent="center" alignItems="center">
                                                    <KeyboardDoubleArrowRightIcon sx={{ fontSize: 35 }} />
                                                </Grid>
                                            </>
                                        )}

                                        {/* MODIFICADO */}
                                        <Grid container xs={5.5} sx={{
                                            backgroundColor: 'lightsalmon',
                                            p: 0.5,
                                            borderLeft: "5px solid salmon",
                                            borderRadius: 2,
                                        }}>
                                            <Typography variant='subtitle1'>Fichaje modificado</Typography>
                                            <Divider sx={{ width: '100%', my: 0.5 }} />

                                            <Typography variant='body2'>
                                                Inicio: {formatearFecha(fichaje.fichaje_modificado.hora_inicio)}
                                            </Typography>
                                            <Typography variant='body2'>
                                                Fin: {formatearFecha(fichaje.fichaje_modificado.hora_fin)}&nbsp;
                                            </Typography>
                                        </Grid>
                                    </>
                                )}

                                {/* === ANULACIÓN === */}
                                {isAnulacion && (
                                    <Grid container xs={12} sx={{
                                        backgroundColor: '#ffe6e6',
                                        p: 0.5,
                                        borderLeft: "5px solid red",
                                        borderRadius: 2,
                                    }}>
                                        <Typography variant='subtitle1'>Fichaje anulado</Typography>
                                        <Divider sx={{ width: '100%', my: 0.5 }} />

                                        <Typography>Inicio: {formatearFecha(fichaje.fichaje_original.hora_inicio)}</Typography>&nbsp;
                                        <Typography>Fin: {formatearFecha(fichaje.fichaje_original.hora_fin)}</Typography>
                                    </Grid>
                                )}

                                {/* BOTONES */}
                                <Grid container xs={12} justifyContent="space-around">
                                    <Divider sx={{ width: '100%', mt: 2 }} />

                                    <Button
                                        onClick={() => setOpen2(index)}
                                    >
                                        <BlockIcon /> Rechazar
                                    </Button>

                                    <Button
                                        variant="contained"
                                        onClick={() => setOpen(index)}
                                    >
                                        <DoneAllIcon /> Aceptar
                                    </Button>
                                </Grid>

                                {/* DIALOGOS */}
                                <DialogAceptarModificacion
                                    open={open}
                                    setOpen={setOpen}
                                    fichaje={fichaje}
                                    tipo={fichaje.tipo}
                                    actualizarFichajePendiente={actualizarFichajePendiente}
                                    index={index}
                                />

                                <DialogRechazarModificacion
                                    open2={open2}
                                    setOpen2={setOpen2}
                                    fichaje={fichaje}
                                    tipo={fichaje.tipo}
                                    actualizarFichajePendiente={actualizarFichajePendiente}
                                    index={index}
                                />

                            </Grid>
                        );
                    })}
                </Grid>
            )}
        </Grid>
    );
};
